import { render, staticRenderFns } from "./LegacyCheckbox.vue?vue&type=template&id=39beb173&scoped=true&"
import script from "./LegacyCheckbox.vue?vue&type=script&lang=js&"
export * from "./LegacyCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./LegacyCheckbox.vue?vue&type=style&index=0&id=39beb173&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39beb173",
  null
  
)

export default component.exports